import React from "react";

const S = {
  page: { background: "#f8fafc", minHeight: "100vh", padding: "0 0 60px", textAlign: "left" },
  hero: {
    background: "linear-gradient(135deg, #0ea5a3 0%, #0f766e 100%)",
    color: "#fff",
    padding: "48px 24px 40px",
    textAlign: "left",
  },
  heroInner: { maxWidth: 780, margin: "0 auto" },
  eyebrow: { fontSize: 13, fontWeight: 700, letterSpacing: 1, opacity: 0.85, textTransform: "uppercase" },
  h1: { fontSize: 30, fontWeight: 800, margin: "8px 0 6px", lineHeight: 1.25 },
  h1Sub: { fontSize: 16, opacity: 0.92, margin: 0 },
  container: { maxWidth: 780, margin: "-24px auto 0", padding: "0 24px" },
  card: {
    background: "#fff",
    borderRadius: 14,
    boxShadow: "0 1px 3px rgba(15,23,42,0.08), 0 8px 24px rgba(15,23,42,0.06)",
    padding: "28px 28px 8px",
    marginBottom: 20,
  },
  section: { marginBottom: 24 },
  sectionHead: { display: "flex", alignItems: "center", gap: 10, marginBottom: 10 },
  icon: { fontSize: 20, lineHeight: 1 },
  h2: { fontSize: 18, fontWeight: 700, color: "#0f172a", margin: 0 },
  p: { fontSize: 15, lineHeight: 1.7, color: "#334155", margin: "0 0 10px" },
  pEn: { fontSize: 14, lineHeight: 1.7, color: "#64748b", margin: "0 0 4px", fontStyle: "italic" },
  ul: { margin: "0 0 10px", paddingLeft: 20 },
  li: { fontSize: 15, lineHeight: 1.7, color: "#334155", marginBottom: 6 },
  divider: { border: "none", borderTop: "1px solid #e2e8f0", margin: "0 0 24px" },
  contactCard: {
    background: "#f0fdfa",
    border: "1px solid #99f6e4",
    borderRadius: 12,
    padding: "20px 22px",
    marginBottom: 20,
  },
  contactRow: { display: "flex", alignItems: "center", gap: 12, marginTop: 10 },
  contactLabel: { fontSize: 13, color: "#0f766e", fontWeight: 600, margin: 0 },
  emailBtn: {
    display: "inline-block",
    marginTop: 6,
    padding: "10px 18px",
    background: "#0ea5a3",
    color: "#fff",
    borderRadius: 8,
    fontWeight: 700,
    fontSize: 14,
    textDecoration: "none",
  },
  footerNote: { fontSize: 12, color: "#94a3b8", textAlign: "center", marginTop: 24 },
};

const Section = ({ icon, title, children }) => (
  <div style={S.section}>
    <div style={S.sectionHead}>
      <span style={S.icon}>{icon}</span>
      <h2 style={S.h2}>{title}</h2>
    </div>
    {children}
    <hr style={S.divider} />
  </div>
);

const ChildSafetyStandards = () => (
  <div style={S.page}>
    <div style={S.hero}>
      <div style={S.heroInner}>
        <div style={S.eyebrow}>Resshare</div>
        <h1 style={S.h1}>Tiêu chuẩn an toàn trẻ em</h1>
        <p style={S.h1Sub}>Child Safety Standards</p>
      </div>
    </div>

    <div style={S.container}>
      <div style={S.card}>
        <Section icon="🛡️" title="Cam kết của chúng tôi">
          <p style={S.p}>
            Resshare không khoan nhượng đối với mọi hình thức bóc lột và xâm hại tình dục trẻ em
            (Child Sexual Abuse and Exploitation — CSAE). Chúng tôi cấm tuyệt đối việc tạo, tải
            lên, lưu trữ, chia sẻ hoặc quảng bá bất kỳ nội dung nào liên quan đến xâm hại tình dục
            trẻ em (Child Sexual Abuse Material — CSAM) trên nền tảng của mình, dưới mọi hình thức.
          </p>
          <p style={S.pEn}>
            We have zero tolerance for child sexual abuse and exploitation (CSAE). Creating,
            uploading, storing, sharing, or promoting any Child Sexual Abuse Material (CSAM) on
            our platform, in any form, is strictly prohibited.
          </p>
        </Section>

        <Section icon="🔍" title="Biện pháp phòng ngừa">
          <ul style={S.ul}>
            <li style={S.li}>Rà soát, gỡ bỏ nội dung vi phạm và khoá tài khoản liên quan ngay khi phát hiện hoặc nhận được báo cáo.</li>
            <li style={S.li}>Cung cấp cơ chế báo cáo ngay trong ứng dụng cho mọi người dùng.</li>
            <li style={S.li}>Hợp tác và báo cáo với cơ quan chức năng có thẩm quyền (trong nước và quốc tế) khi phát hiện nội dung/hành vi vi phạm liên quan đến CSAE.</li>
          </ul>
          <p style={S.pEn}>
            We review and remove violating content and suspend related accounts as soon as they
            are identified or reported. We provide an in-app reporting mechanism for all users,
            and we cooperate with and report to the relevant national and international
            authorities whenever CSAE-related content or behavior is identified.
          </p>
        </Section>

        <Section icon="🚩" title="Báo cáo trong ứng dụng">
          <p style={S.p}>
            Người dùng có thể báo cáo nội dung hoặc hành vi nghi ngờ liên quan đến an toàn trẻ em
            ngay trong ứng dụng Resshare. Mọi báo cáo được xử lý và, khi cần thiết, chuyển tới cơ
            quan chức năng có thẩm quyền theo đúng quy định pháp luật hiện hành.
          </p>
          <p style={S.pEn}>
            Users can report content or behavior suspected of relating to child safety directly
            within the Resshare app. All reports are reviewed and, where required, escalated to
            the relevant authorities in accordance with applicable law.
          </p>
        </Section>

        <div style={{ ...S.section, marginBottom: 0 }}>
          <div style={S.sectionHead}>
            <span style={S.icon}>📩</span>
            <h2 style={S.h2}>Đầu mối liên hệ</h2>
          </div>
          <div style={S.contactCard}>
            <p style={{ ...S.p, marginBottom: 0 }}>
              Đầu mối phụ trách phòng chống CSAE/CSAM của Resshare, sẵn sàng trao đổi về các biện
              pháp tuân thủ.
            </p>
            <p style={{ ...S.pEn, marginTop: 6, marginBottom: 0 }}>
              Designated point of contact for Resshare&apos;s CSAE/CSAM prevention and compliance
              practices.
            </p>
            <div style={S.contactRow}>
              <a href="mailto:resshareteam@gmail.com" style={S.emailBtn}>✉ resshareteam@gmail.com</a>
            </div>
          </div>
        </div>
      </div>

      <p style={S.footerNote}>© Resshare — Saola Information Technology</p>
    </div>
  </div>
);

export default ChildSafetyStandards;
